import axios from "@axios";
import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    exportOrders(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/reports/purchase_orders/export", {
            params: queryParams,
            responseType: "blob",
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchOrders(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/purchase_orders", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProductsBySupplierId(ctx, { supplierId }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/suppliers/${supplierId}/products`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchOrder(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/purchase_orders/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addOrder(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/purchase_orders", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateOrder(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/purchase_orders", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    receiveOrder(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/purchase_orders/receive", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteOrder(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/purchase_orders", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
